<oaibox-warning-message-card gradient="danger" confirmText="Delete" (confirm$)="deleteClient()" (cancel$)="cancel()">
  <div messageTitle>Are you sure you want to delete this Release?</div>
  <div messageBody class="content">
    <oaibox-release-row [release]="release" [displayButtons]="false"></oaibox-release-row>
  </div>
</oaibox-warning-message-card>
